/**
 * Get CRSF token for ajax call
 */
async function getCsrfToken() {

    let url = $('#js-page-dataset').data('get-global-https');
    url = url.replace('CONTROLLER', 'CSRF').replace('ROUTE', 'GetToken');

    const response = await fetch(url, { method: 'POST' });

    let data;
    try {
        data = await response.json();
    } catch (e) {
        data = null;
    }

    if (!response.ok) {
        const msg = data?.errorMessage || data?.message || 'Unable to fetch CSRF token';

        // Log errors
        await logAjaxError(msg);

        throw new Error(msg);
    }

    return {
        token: data.csrf_token || data.csrf.token,
        tokenName: data.csrf_token_name || data.csrf.tokenName
    };
}

/**
 * Log ajax error to server
 */
async function logAjaxError(message) {
    try {
        let url = $('#js-page-dataset').data('get-global-https');
        url = url.replace('CONTROLLER', 'CSRF').replace('ROUTE', 'LogError');

        const formData = new FormData();
        formData.append('error', true);
        formData.append('errorMessage', message);

        await fetch(url, {
            method: 'POST',
            body: formData
        });
    } catch (e) {
        // Se fallisce il logging, non bloccare il flusso
        console.error('Failed to log error:', e);
    }
}

/**
 * Log ajax error to server in non async function
 */
function logAjaxErrorNonAsync(message) {
    var url = $('#js-page-dataset').data('get-global-https');
    url = url.replace('CONTROLLER', 'CSRF').replace('ROUTE', 'LogError');

    var formData = new FormData();
    formData.append('error', true);
    formData.append('errorMessage', message);

    try {
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            body: formData,
            success: (data) => {
            },
            error: (err) => {
            }
        });
    } catch (e) {
        console.error('Failed to log error:', e);
    }
}

/**
 * Get CRSF token for ajax call in non async function
 */
function getCsrfTokenNonAsync() {
    var url = $('#js-page-dataset').data('get-global-https');
    url = url.replace('CONTROLLER', 'CSRF').replace('ROUTE', 'GetToken');

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        success: (data) => {
            return {
                token: data.csrf_token || data.csrf.token,
                tokenName: data.csrf_token_name || data.csrf.tokenName
            };
        },
        error: (err) => {
            const msg = err?.errorMessage || err?.message || 'Unable to fetch CSRF token';
            // Log errors
            logAjaxErrorNonAsync(msg);
            throw new Error(msg);
        }
    });
}


module.exports.methods = {
    getCsrfToken: getCsrfToken,
    getCsrfTokenNonAsync: getCsrfTokenNonAsync
};